import { request } from '@/api/http';

export type LegalDocType = 'terms' | 'privacy_notice' | 'cookie_policy';

export type LegalDocResponse = {
  documentType: string;
  language: string;
  version: string;
  title: string;
  effectiveAt: string | null;
  sha256: string;
  bodyMarkdown: string;
};

export async function fetchCurrentLegalDoc(type: LegalDocType, lang = 'en'): Promise<LegalDocResponse> {
  const qs = new URLSearchParams({ type, lang });
  return request<LegalDocResponse>(`/legal/documents/current?${qs.toString()}`, { skipAuth: true });
}
